// frontend/klaes-app/src/components/FilmFavs/components/Chip.jsx
import { FiX } from 'react-icons/fi';
import { categoryColors } from '../utils/helpers';
import { styles } from '../styles';

export const Chip = ({ label, category, onRemove, onClick, isSelected, size = 'small' }) => {
  const sizeClass = size === 'small' ? styles.compChipSmall : styles.compChipMedium;
  
  return (
    <span 
      className={`${styles.compChip} ${isSelected ? styles.compChipSelected : ''} ${sizeClass}`}
      style={{ backgroundColor: categoryColors[category] || '#6366f1' }}
      onClick={onClick}
    >
      {label}
      {onRemove && <FiX size={12} onClick={(e) => { e.stopPropagation(); onRemove(); }} />}
    </span>
  );
};